module.exports = __webpack_public_path__ + "assets/img/logo.e70b1da6.png";